import { defineTheme } from '@blufin/theme';
import type { ThemeDeclaration } from '@blufin/theme';

/**
 * Canonical default Blufin theme.
 * Cool gray neutrals, blue brand seed, medium radius, system mode.
 */
export const blufinDefault: ThemeDeclaration = defineTheme({
  accent: '#a855f7',
  brand: '#3b82f6',
  defaultMode: 'system',
  diverging: {
    negative: '#ef4444',
    positive: '#22c55e'
  },
  feedback: {
    danger: '#ef4444',
    info: '#06b6d4',
    success: '#22c55e',
    warning: '#f59e0b'
  },
  gray: 'cool',
  name: 'blufin-default',
  radius: 'md'
});
